export default{
	baseUrl:'https://admin.yubo327.com/',
	baseUrl:'https://api.yubo327.com/',
	// baseUrl:'http://a.yubo.cc/',
}